import styled from 'styled-components';
export var RangeContainer = styled.div.withConfig({
  displayName: "style__RangeContainer",
  componentId: "sc-1xhhww5-0"
})(["color:\xB7#000;display:inline-block;"]);
export var PanelContainer = styled.div.withConfig({
  displayName: "style__PanelContainer",
  componentId: "sc-1xhhww5-1"
})(["display:flex;justify-content:flex-start;"]);
export var ButtonContainer = styled.div.withConfig({
  displayName: "style__ButtonContainer",
  componentId: "sc-1xhhww5-2"
})(["margin-top:12px;display:inline-block;order:0;margin-left:35px;"]);
export var PanelBody = styled.div.withConfig({
  displayName: "style__PanelBody",
  componentId: "sc-1xhhww5-3"
})(["width:95%;height:84px;padding:15px;"]);
export var LegendContainer = styled.div.withConfig({
  displayName: "style__LegendContainer",
  componentId: "sc-1xhhww5-4"
})(["min-height:450px;max-height:450px;"]);